import { Component, inject, OnInit } from '@angular/core';
import { UIConfirmDialogResult, UIDialogComponent, UINewThemeService } from '@bannerflow/ui';
import { HeavyVideoService } from '../../services/heavy-video.service/heavy-video.service';

@Component({
    selector: 'heavy-video-warning-dialog',
    templateUrl: './heavy-video-warning-dialog.component.html',
    styleUrls: ['./heavy-video-warning-dialog.component.scss'],
    standalone: false
})
export class HeavyVideoWarningDialogComponent implements OnInit {
    private uiNewThemeService = inject(UINewThemeService);

    private closePromise: Promise<UIConfirmDialogResult>;
    private resolveClosePromise: (result: UIConfirmDialogResult) => void;

    hasConfirmed: boolean;
    allowHeavyVideo: boolean;
    heavyVideoSizeLimit: number;

    private heavyVideoService = inject(HeavyVideoService);
    private dialog = inject(UIDialogComponent);
    protected isNewUI = this.uiNewThemeService.isNewThemeEnabled;

    constructor() {
        this.hasConfirmed = false;
    }

    ngOnInit(): void {
        this.allowHeavyVideo = this.dialog.config.data.allowHeavyVideo;
        this.heavyVideoSizeLimit = this.heavyVideoService.getHeavyVideoSizeLimit();
    }

    initiate(): Promise<UIConfirmDialogResult> {
        if (!this.closePromise) {
            this.closePromise = new Promise(resolve => (this.resolveClosePromise = resolve));
        }
        return this.closePromise;
    }

    confirm(): void {
        this.resolveClosePromise('confirm');
        this.close();
    }

    cancel(): void {
        this.resolveClosePromise('cancel');
        this.close();
    }

    private close(): void {
        this.dialog.dialogRef.close();
    }
}
